__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@securitize/bc-control-panel-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.4", () => (Promise.all([__webpack_require__.e(908), __webpack_require__.e(443), __webpack_require__.e(464)]).then(() => (() => (__webpack_require__(47083))))));
			register("@emotion/styled", "11.11.5", () => (Promise.all([__webpack_require__.e(443), __webpack_require__.e(21), __webpack_require__.e(93)]).then(() => (() => (__webpack_require__(474))))));
			register("@mui/icons-material", "5.15.19", () => (Promise.all([__webpack_require__.e(908), __webpack_require__.e(197), __webpack_require__.e(376), __webpack_require__.e(443), __webpack_require__.e(21), __webpack_require__.e(750), __webpack_require__.e(812)]).then(() => (() => (__webpack_require__(54376))))));
			register("@mui/material", "5.15.19", () => (Promise.all([__webpack_require__.e(908), __webpack_require__.e(197), __webpack_require__.e(318), __webpack_require__.e(889), __webpack_require__.e(420), __webpack_require__.e(672), __webpack_require__.e(746), __webpack_require__.e(443), __webpack_require__.e(21), __webpack_require__.e(750), __webpack_require__.e(311), __webpack_require__.e(64)]).then(() => (() => (__webpack_require__(26746))))));
			register("@mui/x-data-grid", "7.7.1", () => (Promise.all([__webpack_require__.e(908), __webpack_require__.e(197), __webpack_require__.e(318), __webpack_require__.e(889), __webpack_require__.e(420), __webpack_require__.e(531), __webpack_require__.e(443), __webpack_require__.e(21), __webpack_require__.e(750), __webpack_require__.e(311), __webpack_require__.e(431)]).then(() => (() => (__webpack_require__(8531))))));
			register("@reduxjs/toolkit", "2.2.5", () => (__webpack_require__.e(487).then(() => (() => (__webpack_require__(76487))))));
			register("@securitize/bc-common", "1.0.0", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(443), __webpack_require__.e(234), __webpack_require__.e(993)]).then(() => (() => (__webpack_require__(746))))));
			register("axios", "1.7.2", () => (__webpack_require__.e(373).then(() => (() => (__webpack_require__(76373))))));
			register("history", "4.10.1", () => (__webpack_require__.e(39).then(() => (() => (__webpack_require__(99420))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(989), __webpack_require__.e(443)]).then(() => (() => (__webpack_require__(43989))))));
			register("react-redux", "9.1.2", () => (Promise.all([__webpack_require__.e(588), __webpack_require__.e(443)]).then(() => (() => (__webpack_require__(15588))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(396), __webpack_require__.e(443), __webpack_require__.e(162)]).then(() => (() => (__webpack_require__(47396))))));
			register("react", "18.3.1", () => (__webpack_require__.e(176).then(() => (() => (__webpack_require__(72176))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};